import 'web-animations-js';
import 'zone.js';
import '@angular/localize/init';
import 'hammerjs';